var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M14.583 14.136c-.739 0-1.4.302-1.905.774l-6.932-4.167a3.39 3.39 0 0 0 .087-.703c0-.24-.039-.472-.087-.703L12.6 5.211a2.855 2.855 0 0 0 1.983.813c1.614 0 2.917-1.345 2.917-3.012S16.197 0 14.583 0c-1.614 0-2.916 1.345-2.916 3.012 0 .241.039.472.087.703L4.9 7.84a2.855 2.855 0 0 0-1.983-.813C1.303 7.028 0 8.373 0 10.04s1.303 3.012 2.917 3.012c.768 0 1.458-.311 1.983-.813l6.922 4.177a2.92 2.92 0 0 0-.078.652c0 1.617 1.274 2.932 2.84 2.932 1.565 0 2.838-1.315 2.838-2.932 0-1.616-1.273-2.932-2.839-2.932Z",
    fill: "currentColor"
  })));
};
export default SvgShare;